<template>
  <div>
    <div class="dept-box">
      <div class="depttree-box">
        <div class="department">
          <eltrees @childerdepartment="childerdepartment" :parentIdOne="parentIdOne"></eltrees>
        </div>
      </div>
      <div class="select-box" v-if="zuo">
        <div class="exam-select">
          <div class="info-box">
            <div class="contain-box">
              <div class="img-box">
                <img src="@/assets/exam/u12442.png" />
              </div>
              <div class="text-box">
                <span style="font-weight: 700">培训班总人数</span>
                <span>{{ peopleNum.SumNum }}人</span>
              </div>
            </div>
            <div class="contain-box">
              <div class="img-box img2">
                <img src="@/assets/exam/signup-1.png" />
              </div>
              <div class="text-box">
                <span style="font-weight: 700">已报名</span>
                <span>{{ peopleNum.BmNum }}人</span>
              </div>
            </div>
            <div class="contain-box">
              <div class="img-box img3">
                <img src="@/assets/exam/u12441.png" />
              </div>
              <div class="text-box">
                <span style="font-weight: 700">下发部门</span>
                <span>{{ peopleNum.DeptPeoNum }}个</span>
              </div>
            </div>
            <div class="contain-box">
              <div class="img-box img4">
                <img src="@/assets/exam/u12439.png" />
              </div>
              <div class="text-box">
                <span style="font-weight: 700">下发部门人数</span>
                <span>{{ peopleNum.DeptNum }}人</span>
              </div>
            </div>
          </div>
        </div>

        
        <el-table
          :data="ExaminersTable"
          border
          height="405"
          style="width: 100%;margin-top: 10px;"
          :row-style="selectedHighlight"
          :cell-style="{ 'text-align': 'center' }"
        >
          <el-table-column
            align="center"
            type="index"
            min-width="10"
          ></el-table-column>
          <el-table-column
            prop="deptName"
            label="所在单位"
            align="center"
            min-width="100"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            label="报送人数"
            align="center"
            min-width="50"
          >
            <template slot-scope="scope">
              <el-input v-model="scope.row.num" placeholder="请输入人数" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            min-width="50"
          >
            <template slot-scope="scope">
              <el-button type="danger"  @click="deleteTask(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import eltrees from "@/components/Eltree"; //部门树形结构异步加载
import * as TrainTask from "@/api/train/trainTask";

export default {
  props:['trainId'],
  components: {
    eltrees,
  },
  data() {
    
    return {
      taskIndex:1,
      flagJia: true,
      addShow: null,
      listQuery: {
        //数的查询条件
        page: 1,
        limit: 20,
        trainId: 0,
        userName: null,
        userCode: null,
        idCard: null,
        detpName: null,
      },
      zuo: true,
      you: false,
      zuobtn: false,
      youbtn: true,
      
      ExaminersTable: [],
      total: 0,
      form: null,
      flag: false,
      parentIdOne:JSON.parse(this.$store.state.User.infos).deptId,
      peopleNum:{},

    };
  },
  created(){
      if(this.trainId!==0){
        this.getList()
        this.getTaskDeptCount()
      }
      
  },
  methods: {
    //获取报名的人数和报送单位的人数
    getTaskDeptCount() {
      let para = {
        trainId: this.trainId,
        deptId: JSON.parse(this.$store.state.User.infos).deptId,
      };
      TrainTask.getTaskDeptCount(para).then((res) => {
        this.peopleNum = res.result;
      });
    },
    updateTask(){
      let _this=this
      let taskNum=0
      if( this.ExaminersTable.length>0){
        for (let index = 0; index < this.ExaminersTable.length; index++) {
          taskNum+=parseInt(this.ExaminersTable[index].num)
        }
      }
      let peopleLength=_this.peopleNum.BmNum + taskNum
      if(peopleLength>_this.peopleNum.SumNum){
        return this.$message.error("报送人数不能超过总人数，请重新报送！")
      }
      let para={
        trainId:this.trainId,
        deptId:JSON.parse(this.$store.state.User.infos).deptId
      }
      
      TrainTask.updateTask(para,_this.ExaminersTable).then((res)=>{
        if(res.code==200){
          this.$message.success("修改成功！")
        }
      })
    },
    deleteTask(row){
     for (let i = 0; i < this.ExaminersTable.length; i++) {
        if (this.ExaminersTable[i].id == row.id) {
          this.ExaminersTable.splice(i, 1);
        }
      }
    },
    getList(){
      let para={
        trainId: this.trainId,
        deptId:JSON.parse(this.$store.state.User.infos).deptId
      }
      TrainTask.getList(para).then((res)=>{
        this.ExaminersTable=res.result
      })
    },
    //添加下发任务
    addTask() {
      this.ExaminersTable.forEach((item) => {
        item.trainId= this.trainId
        
      });
      let para={
        trainId:this.trainId,
      }

      TrainTask.add(para,this.ExaminersTable).then((res) => {
        if (res.code == 200) {

        }
      });
    },
    selectedHighlight({ row }) {
      if (row.status == true) {
        return {
          "background-color": "#409EFF",
        };
      }
    },
    childerdepartment(val,row) {
      let _this=this
      let data={
        trainId: this.trainId,
        deptId:parseInt(val),
        deptName:row.label,
        num:0,
        createId:parseInt(this.$store.state.User.ids),
      }
       _this.ExaminersTable.push(data);
       var arr3 = _this.ExaminersTable
        let deWeightThree = () => {
            let map = new Map();
            for (let item of arr3) {
                if (!map.has(item.deptName)) {
                    map.set(item.deptName, item);
                }
            }
            return [...map.values()];
        }
         _this.ExaminersTable = deWeightThree();
    }
  },
};
</script>

<style lang="scss" scoped>
.dept-box {
  display: flex;
  border: 1px solid rgb(226, 223, 223);
  padding: 20px;
  .depttree-box {
    border: 1px solid rgb(226, 223, 223);
    width: 300px;
    padding: 10px;
    .title-text {
      font-size: 20px;
      font-weight: 700;
    }
    .department {
      margin-top: 20px;
      height: 400px;
      overflow-y: auto;
    }
  }
  .select-box {
    padding: 0 20px;
    width: 100%;
    .exam-select {
      display: flex;
      justify-content: space-between;
      .el-input {
        width: 150px;
      }
      .button-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 20%;
      }
      .input-box {
        display: flex;
        width: 600px;
      }
    }
  }
}
.info-box {
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .contain-box {
    width: 200px;
    display: flex;
  }
  .img-box {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("../../../../assets/exam/u12419.svg");
    border-radius: 50%;
    background-repeat: no-repeat;
    zoom: 0.8;
  }
  .img2 {
    background-image: url("../../../../assets/exam/signup-2.svg");
  }
  .img4 {
    background-image: url("../../../../assets/exam/signup-6.svg");
  }
  .img3 {
    background-image: url("../../../../assets/exam/signup-8.svg");
  }
  .img5 {
    background-image: url("../../../../assets/exam/signup-9.svg");
  }
  .text-box {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding: 0 10px;
    line-height: 20px;
  }
  img {
    width: 36px;
    height: 36px;
  }
}
</style>